import fetch from '../utils/fetch'

export function getLogisticsLists (query) {
  return fetch({
    url: '/company/logistics/list',
    method: 'get',
    params: query
  })
}

export function createCompanyLogistics (params) {
  return fetch({
    url: '/company/logistics/create',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function deleteCompanyLogistics (id) {
  return fetch({
    url: '/company/logistics/' + id,
    method: 'delete'
  })
}